export const FALLBACK_ERROR_MESSAGE = 'An unexpected error occurred.';
